import { useEffect, useState } from "react";
import Switch from "react-switch";
import Select from "react-select";
import { useStore } from "../../../store";
import { toJS } from "mobx";
import DateTime from "../../../components/DateTime";
import moment from "moment";
import MySelect from "../../../components/MySelect";

function MenuSettingDate() {
  const { dataStore } = useStore();
  //按钮按下
  const resData = toJS(dataStore).resData;

  const utcOptions = [
    { "value": '+00:00', label: '+00:00' },
    { "value": '+01:00', label: '+01:00' },
    { "value": '+02:00', label: '+02:00' },
    { "value": '+03:00', label: '+03:00' },
    { "value": '+03:30', label: '+03:30' },
    { "value": '+04:00', label: '+04:00' },
    { "value": '+04:30', label: '+04:30' },
    { "value": '+05:00', label: '+05:00' },
    { "value": '+05:30', label: '+05:30' },
    { "value": '+05:45', label: '+05:45' },
    { "value": '+06:00', label: '+06:00' },
    { "value": '+06:30', label: '+06:30' },
    { "value": '+07:00', label: '+07:00' },
    { "value": '+08:00', label: '+08:00' },
    { "value": '+08:45', label: '+08:45' },
    { "value": '+09:00', label: '+09:00' },
    { "value": '+09:30', label: '+09:30' },
    { "value": '+10:00', label: '+10:00' },
    { "value": '+10:30', label: '+10:30' },
    { "value": '+11:00', label: '+11:00' },
    { "value": '+12:00', label: '+12:00' },
    { "value": '+12:45', label: '+12:45' },
    { "value": '+13:00', label: '+13:00' },
    { "value": '+14:00', label: '+14:00' },
    { "value": '-01:00', label: '-01:00' },
    { "value": '-02:00', label: '-02:00' },
    { "value": '-03:00', label: '-03:00' },
    { "value": '-03:30', label: '-03:30' },
    { "value": '-04:00', label: '-04:00' },
    { "value": '-04:30', label: '-04:30' },
    { "value": '-05:00', label: '-05:00' },
    { "value": '-05:30', label: '-05:30' },
    { "value": '-06:00', label: '-06:00' },
    { "value": '-07:00', label: '-07:00' },
    { "value": '-08:00', label: '-08:00' },
    { "value": '-09:00', label: '-09:00' },
    { "value": '-10:00', label: '-10:00' },
    { "value": '-11:00', label: '-11:00' },
    { "value": '-12:00', label: '-12:00' }
  ]



  const onChangeAutomatically = function () {
    setSpinner(true)

    dataStore.sendData({
      action: 'updateSetting',
      data: {
        key: 'automaticTimeEnabled',
        value: !resData.loadSettingAck?.automaticTimeEnabled,
      }
    })


  };

  let [currentDate, setCurrentDate] = useState({
    year: moment().year().toString(),
    month: (moment().month() + 1).toString(),
    day: moment().date().toString(),
    hour: moment().format("h:m:A").split(":")[0],
    minutes: moment().format("h:m:A").split(":")[1],
    ap: moment().format("h:m:A").split(":")[2],
  });

  const [spinner, setSpinner] = useState(false)


  useEffect(() => {

    setSpinner(false)
    
  }, [resData.loadSettingAck?.automaticTimeEnabled])

  // 更新当前日期
  function onChangeDateTime(type: string, value: string) {
    setCurrentDate({
      ...currentDate,
      [type]: value,
    });
  }


  const onChangeTimezone = (value: string) => {
    dataStore.sendData({
      action: 'updateSetting',
      data: {
        key: 'timeZone', value
      }
    })
  }

  const onChangeTwentyFourHourTimeEnabled = (value: any) => {
    dataStore.sendData({
      action: 'updateSetting',
      data: {
        key: 'twentyFourHourTimeEnabled', value
      }
    })
  }

  const onChangeCurrentTime = (value: any) => {
    dataStore.sendData({
      action: 'updateSetting',
      data: {
        key: 'currentTime', value
      }
    })
  }


  useEffect(() => {
    if (!resData.loadSettingAck?.automaticTimeEnabled) {
      setCurrentDate({
        year: moment().year().toString(),
        month: (moment().month() + 1).toString(),
        day: moment().date().toString(),
        hour: moment().format("h:m:A").split(":")[0],
        minutes: moment().format("h:m:A").split(":")[1],
        ap: moment().format("h:m:A").split(":")[2],
      })
    }


  }, [resData.loadSettingAck?.automaticTimeEnabled])


  useEffect(() => {

    if (!resData.loadSettingAck?.automaticTimeEnabled) {
      const formattedDate = moment(
        `${currentDate.year}-${currentDate.month}-${currentDate.day} ${currentDate.hour}:${currentDate.minutes} ${currentDate.ap}`,
        "YYYY-M-D h:mm A"
      ).format("YYYY-MM-DD HH:mm:ss");

      if (formattedDate !== 'Invalid date') {
        onChangeCurrentTime(formattedDate)
      }
    }

  }, [currentDate])




  return (
    <div className="w-4/6 relative mr-10">
      <div className="border-2 rounded-2xl absolute inset-0 m-auto h-4/6 opacity-1 mr-10"
        style={{
          backgroundColor: 'rgba(212,115,0,0.5)',
          boxShadow: "8px 8px 8px  rgba(0, 0, 0, 0.3)",
        }}
      >
        <div className="h-[500px] overflow-auto m-10">
          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              24-hour Time
            </span>

            <div
              className="mt-[7px] float-right"
              style={{
                width: 130,
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Switch
                onChange={onChangeTwentyFourHourTimeEnabled}
                checked={!!resData.loadSettingAck?.twentyFourHourTimeEnabled}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor={"#5ede4e"}
              />
            </div>


          </div>


          <br></br>
          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              Set Automatically
            </span>
            <div
              className="mt-[7px] float-right"
              style={{
                width: 130,
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Switch
                onChange={onChangeAutomatically}
                checked={!!resData.loadSettingAck?.automaticTimeEnabled}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor={"#5ede4e"}
              />
            </div>
          </div>
          <br></br>

          <div className="h-12 px-28">
            <span className="float-left text-white text-3xl mt-1">
              Time Zone
            </span>
            <MySelect
              value={utcOptions.find(item => item.value === resData.loadSettingAck?.timeZone)}
              options={utcOptions}
              className="w-[130px] float-right mt-[1px]"
              onChange={e => onChangeTimezone(e.value)}
            />
          </div>
          <br></br>
          {
            !resData.loadSettingAck?.automaticTimeEnabled ? (
              <div className="mt-10 px-28">
                <DateTime
                  style={{
                    borderWidth: 1.5,
                  }}
                  options={{
                    type: "year",
                    cb: (value) => {
                      onChangeDateTime("year", value);
                    },
                    defaultValue: currentDate.year,
                  }}
                />

                <DateTime
                  style={{
                    borderWidth: 1.5,
                  }}
                  options={{
                    type: "month",
                    cb: (value) => {
                      onChangeDateTime("month", value);
                    },
                    defaultValue: currentDate.month,
                  }}
                />

                <DateTime
                  style={{
                    borderWidth: 1.5,
                  }}
                  options={{
                    type: "day",
                    cb: (value) => {
                      onChangeDateTime("day", value);
                    },
                    defaultValue: currentDate.day,
                  }}
                />

                <DateTime
                  style={{
                    borderWidth: 1.5,
                  }}
                  options={{
                    type: "hour",
                    cb: (value) => {
                      onChangeDateTime("hour", value);
                    },
                    defaultValue: currentDate.hour,
                  }}
                />

                <DateTime
                  style={{
                    borderWidth: 1.5,
                  }}
                  options={{
                    type: "minutes",
                    cb: (value) => {
                      onChangeDateTime("minutes", value);
                    },
                    defaultValue: currentDate.minutes,
                  }}
                />

                <DateTime
                  style={{
                    borderWidth: 1.5,
                  }}
                  options={{
                    type: "ap",
                    cb: (value) => {
                      onChangeDateTime("ap", value);
                    },
                    defaultValue: currentDate.ap,
                  }}
                />
              </div>
            ) : undefined
          }

          {spinner && (
            <div
              style={{
                opacity: 0.2,
                backgroundColor: 'white',
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              }}
            />
          )}


        </div>


      </div>
    </div>
  );
}
export default MenuSettingDate;
